// extracted by mini-css-extract-plugin
export var triangle = "styles-module--triangle--46e19";
export var wrapper = "styles-module--wrapper--faade";